export const createError = (error, id = Date.now()) => ({
	__typename: "UnexpectedError",
	id,
	code: 500,
	message: error.message,
	stack: error.stack,
	originalError: {
		__typename: "JustError",
		name: error.name,
		message: error.message,
	},
});
